import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Button } from '../../../subcomponents/button/button';
import { ButtonColor } from '../../../subcomponents/button/types/color';
import { clearFilter } from '../../../utils/filters/clear-filter';
import { allFilterOptionValue } from '../../../utils/filters/constants';
import { getNumberOfFiltersApplied } from '../../../utils/filters/get-number-of-filters-applied';
import { setFilterValue } from '../../../utils/filters/set-filter-value';
import { CompositeFilterAccordion } from './accordion';
const b = bemClassBuilder('v-composite-filter-inline');
export const CompositeFilterInline = observer(props => {
    const { displayText, sectionsToDisplay, filter, cdnOptions } = props;
    const filterKeys = sectionsToDisplay.map(section => section.key);
    const filterType = filter.type;
    const hasFiltersApplied = getNumberOfFiltersApplied({ id: filter.id, type: filterType, keys: filterKeys }) > 0;
    const clearFilters = () => {
        if (!hasFiltersApplied)
            return;
        clearFilter({ id: filter.id, type: filterType, keys: filterKeys });
    };
    const handleChange = (filterKey, filterValue, selected, multiselect) => {
        if (filterValue === allFilterOptionValue) {
            clearFilter({ id: filter.id, type: filterType, keys: [filterKey] });
            return;
        }
        setFilterValue({
            id: filter.id,
            type: filterType,
            key: filterKey,
            value: filterValue,
            multiselect,
            selected
        });
    };
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsxs("header", Object.assign({ className: b.element('header') }, { children: [_jsx("h4", Object.assign({ className: b.element('title') }, { children: displayText.filterTitleLabel })), hasFiltersApplied && (_jsx(Button, Object.assign({ className: b.element('clear-button'), color: ButtonColor.Secondary, type: "reset", onClick: clearFilters }, { children: displayText.accordionHeaderClearFiltersButtonLabel })))] })), _jsx(CompositeFilterAccordion, { filter: filter, sectionsToDisplay: sectionsToDisplay, displayText: displayText, expandAccordionSectionsByDefault: false, onChange: handleChange, cdnOptions: cdnOptions })] })));
});
CompositeFilterInline.displayName = 'CompositeFilterInline';
